import React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import { strategyTranslation } from 'modules/performance_process/lib/reviewStrategy'

type Props = {
  strategy: PerformanceReviewerStrategiesStrategyEnum
  onNavigateToStrategyWeight: () => void
}

export const MissingStrategyWeightCallout = ({ strategy, onNavigateToStrategyWeight }: Props) => {
  const strategyName = strategyTranslation(strategy)
  return (
    <Callout
      type="info"
      title={i18n.t('performance_process.score_strategy_weights.missing_weight_callout.title', {
        strategyName: strategyName,
      })}
      description={i18n.t(
        'performance_process.score_strategy_weights.missing_weight_callout.description',
        {
          strategyName: strategyName,
        }
      )}
      hideIcon={false}
      action={
        <Button type="secondary" onClick={onNavigateToStrategyWeight}>
          {i18n.t(
            'performance_process.score_strategy_weights.missing_weight_callout.change_weight'
          )}
        </Button>
      }
    />
  )
}
